/* eslint no-underscore-dangle: 0 */
/* eslint func-names: ["error", "never"] */
window.__isIE11 = function () {
  return !!window.MSInputMethodContext && !!document.documentMode
}
window.__isEdge = function () {
  return window.navigator.userAgent.indexOf('Edge') > -1
}
window.HTMLElement.prototype.hasClass = function (className) {
  return this.classList.contains(className)
}
window.HTMLElement.prototype.addClass = function (className) {
  this.classList.add(className)
}
window.HTMLElement.prototype.removeClass = function (className) {
  this.classList.remove(className)
}
window.HTMLElement.prototype.toggleClass = function (className, force = null) {
  if (force === null) {
    if (this.hasClass(className)) {
      this.removeClass(className)
    } else {
      this.addClass(className)
    }
  } else if (force) {
    this.addClass(className)
  } else {
    this.removeClass(className)
  }
}
window.HTMLElement.remove = function () {
  this.parentNode.removeChild(this)
}
window.HTMLElement.prototype.onClick = function (callback) {
  this.onclick = callback
}
window.HTMLElement.prototype.onHover = function (callbackIn, callbackOut) {
  this.addEventListener('mouseover', callbackIn)
  this.addEventListener('mouseout', callbackOut)
}
window.isTouch = function () { // requires Modernizr
  return document.querySelector('html').hasClass('touchevents')
}

window.isForceTouch = function () { // requires Modernizr
  return document.querySelector('html').hasClass('forcetouch')
}
